import React, { forwardRef } from 'react';

import { cn } from '@/app/shared/lib/cn';

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  loading?: boolean;
  className?: string;
}

const Line = forwardRef<HTMLDivElement, SkeletonProps>(
  ({ loading, className = '', style, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(loading && 'animate-pulse rounded-md bg-gray-800', className)}
        style={{
          animationDuration: loading ? '1.5s' : undefined,
          ...style,
        }}
        {...props}
      >
        <div className={cn(loading && 'invisible')}>{children}</div>
      </div>
    );
  },
);

const Circle = forwardRef<HTMLDivElement, SkeletonProps>(
  ({ loading, className = '', style, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(loading && 'animate-pulse rounded-full bg-gray-800', className)}
        style={{
          animationDuration: loading ? '1.5s' : undefined,
          ...style,
        }}
        {...props}
      >
        <div className={cn(loading && 'invisible')}>{children}</div>
      </div>
    );
  },
);

const Skeleton = {
  Line: Line,
  Circle: Circle,
};

export { Skeleton };
